/* istanbul ignore file */
import { useState } from 'react';
import styled from 'styled-components';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { SYNCED_TEAM_MODEL } from '../../../settings/views/ContributorsAndTeams/Teams/teams.model';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';
import { CAN_EDIT_ACCOUNT_TYPES } from '@linearb/linjs-common';
import { useAllTeams } from 'components/hooks/useAllTeams';

const MenuIcon = styled.div`
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const ActionsMenu = ({ team, isTeamLicense, onEdit, onDelete, isGroup }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { isAllTeams = false } = useAllTeams();
  const isOpen = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const myAccount = useSelector(myAccountSelector);
  const isCurrentUserAdmin = isAdmin(myAccount) || isSuperUser(myAccount);
  const isTeamSynced = get(team, SYNCED_TEAM_MODEL.IS_SYNCED);
  const shouldShowDeleteButton =
    !isTeamLicense && !isTeamSynced && isCurrentUserAdmin;
  const canUserEdit = CAN_EDIT_ACCOUNT_TYPES.includes(myAccount?.type_id);

  if (!canUserEdit) {
    return <></>;
  }

  return (
    <>
      {!isAllTeams && (
        <Flex items='center' justify='center'>
          <MenuIcon>
            <Icon name='moreVert' size='medium' onClick={handleClick} />
          </MenuIcon>
          <Menu
            id='simple-menu'
            anchorEl={anchorEl}
            open={isOpen}
            onClose={handleClose}
            onBlur={handleClose}
          >
            <MenuItem onClick={onEdit}>
              <Text size='medium' padding='0.5rem'>
                {isGroup ? 'Edit Group' : 'Edit Team'}
              </Text>
            </MenuItem>
            {shouldShowDeleteButton && (
              <MenuItem onClick={onDelete}>
                <Text size='medium' padding='0.5rem'>
                  {isGroup ? 'Delete Group' : 'Delete Team'}
                </Text>
              </MenuItem>
            )}
          </Menu>
        </Flex>
      )}
    </>
  );
};

export default ActionsMenu;
